let timer;
export default function debounce(func, delay = 400) {
	clearTimeout(timer);
	timer = setTimeout((...args) => func.apply(this, args), delay);
}
